import { defineMeta } from '@/registry/types';

export const formFieldMeta = defineMeta({
  name: 'FormField',
  level: 'molecule',
  category: 'input',
  classification: 'mui-wrapper',
  description: 'Consistent label + control + helper/error wrapper for any form input.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'FormControl (composed)',
  muiDocs: 'https://mui.com/material-ui/api/form-control/',
  a2uiEquivalent: 'FormField',
  importPath: '@/molecules/FormField',
  requiredProps: ['label', 'children'],
  optionalProps: ['helperText', 'error', 'required', 'htmlFor', 'fullWidth'],
  supportedStates: ['default', 'required', 'error'],
  designTokens: ['typography', 'spacing'],
  accessibility: ['Use htmlFor + control id to associate the label with the input.'],
  usageExamples: ['<FormField label="Email" htmlFor="email" helperText="Shown throughout the console."><TextField id="email" /></FormField>'],
  rules: [
    'The label is the caption variant and helper text is caption. Pass them as props — do not wrap the label in Typography.',
  ],
  antiPatterns: ['Do not nest multiple unrelated controls in one FormField.'],
  llmSafe: true,
  whenToUse: ['Any labeled form input', 'Composite filter/form sections'],
  whenNotToUse: ['Standalone controls without labels'],
});

export default formFieldMeta;
